import ReducersFactory from '../../lib/reducers/ReducersFactory';

const answers = new ReducersFactory('answers', [])


export default answers.reducer